<template>
  <div class="add-box">
    <el-button type="primary" :disabled="loading" @click="loadDetail">
      <slot></slot>
    </el-button>

    <el-drawer
        title="新增"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="false"
        :before-close="closeHandle"
    >
      <el-row>
        <el-col :span="12" :offset="6">
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <el-form label-width="100px">
              <el-row>

                <el-col :span="24">
                  <validation-provider rules="required" name="套餐类型" v-slot="{ errors }">
                    <el-form-item label="套餐类型" :error="errors[0]">
                      <el-select v-model="form.type_id" placeholder="请选择套餐类型">
                        <el-option
                            v-for="(item, i) in typeList"
                            :key="i"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <validation-provider rules="required" name="名称" v-slot="{ errors }">
                    <el-form-item label="名称" :error="errors[0]">
                      <el-input v-model="form.name" clearable placeholder="请填写名称"></el-input>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <validation-provider rules="required" name="支付价格" v-slot="{ errors }">
                    <el-form-item label="支付价格" :error="errors[0]">
                      <el-input type="number" v-model="form.pay_price" clearable placeholder="请填写支付价格"></el-input>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <validation-provider rules="required" name="原价" v-slot="{ errors }">
                    <el-form-item label="原价" :error="errors[0]">
                      <el-input type="number" v-model="form.pay_raw_price" clearable placeholder="请填写原价"></el-input>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <validation-provider rules="required" name="有效时长" v-slot="{ errors }">
                    <el-form-item label="有效时长(天)" :error="errors[0]">
                      <el-input-number v-model="form.duration" :min="1" :max="100000"></el-input-number>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <validation-provider rules="required" name="排序数字" v-slot="{ errors }">
                    <el-form-item label="排序数字" :error="errors[0]">
                      <el-input-number v-model="form.sort" :min="1" :max="1000"></el-input-number>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <el-form-item>
                    <el-button type="primary" :disabled="submitIng" @click="handleSubmit(onSubmit)">
                      {{ submitIng ? '提交中...' : '提交' }}
                    </el-button>
                    <el-button @click="closeHandle">取消</el-button>
                  </el-form-item>
                </el-col>

              </el-row>
            </el-form>
          </validation-observer>
        </el-col>
      </el-row>
    </el-drawer>

  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      user: {},
      loading: false,
      query: {},
      typeList: [],
      form: {
        type_id: '',
        name: '',
        pay_price: '',
        pay_raw_price: '',
        duration: '',
        sort: 1,
      },
      submitIng: false,
      openStatus: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  mounted() {
  },
  methods: {
    loadDetail() {
      const _this = this;
      _this.loading = true;
      _this.form = {
        type_id: '',
        name: '',
        pay_price: '',
        pay_raw_price: '',
        duration: '',
        sort: 1,
      }
      _this.$apiAdmin.adminSchemeCreateDetail(_this.query)
          .then(res => {
            _this.openStatus = true;
            _this.loading = false;
            _this.typeList = res.type_list;
          })
          .catch(err => {
            _this.loading = false;
            _this.openStatus = false;
          })
    },
    onSubmit() {
      const _this = this;
      _this.submitIng = true;
      _this.$apiAdmin.adminSchemeCreate(_this.form)
          .then((res) => {
            _this.submitIng = false;
            _this.$message.success('新增成功')
            _this.$emit('finish', {
              type_id: _this.form.type_id,
            })
            _this.closeHandle();
          })
          .catch(err => {
            _this.submitIng = false;
            _this.$message.error(err.msg)
          })
    },
    closeHandle() {
      const _this = this;
      _this.openStatus = false;
      _this.form = {
        type_id: '',
        name: '',
        pay_price: '',
        pay_raw_price: '',
        duration: '',
        sort: 1,
      }
    }
  }
}
</script>

<style scoped>
.add-box {
  padding-right: 10px;
}
</style>